
export class Fullpage {

    /**
     * @public
     */
    static guidepost()
    {
        const $ = jQuery;

        const duplicateFooter = document.querySelector('.fp-footer-special');
        const fullpageRoot = document.getElementById('fullpage');

        if (fullpageRoot) {
            if (window.matchMedia('(min-width:1280px) and (min-height:900px)').matches && document.body.classList.contains('page-template-guidepost-page')) {
                $('#fullpage').fullpage({
                    afterLoad: function (anchorLink, index) {
                        const active = document.querySelector('.fp-section.active');
                        active.classList.remove('leaving');
                    },
                    sectionSelector: '.fp-stage-box',
                    afterRender: function(){

                        if (window.location.hash) {
                            const activeSection = document.querySelector(window.location.hash);
                            const allStageBox = document.querySelectorAll('.stage-box');
                            if (activeSection && allStageBox) {
                                const section = activeSection.closest('.stage-box');

                                if (section) {
                                    const index = parseInt(section.getAttribute('data-index')) + 1;

                                    let i = 1;
                                    while (i < index) {
                                        allStageBox[i-1].classList.add('already-animated');
                                        i++;
                                    }

                                    $.fn.fullpage.moveTo(index, 0);

                                    setTimeout(() => {
                                        $.fn.fullpage.reBuild();
                                        section.classList.add('beforeScroll');
                                    },400);

                                    setTimeout(() => {
                                        fullpageRoot.classList.add('visible');
                                        section.classList.add('afterScroll');
                                    },600);
                                }
                            }
                        } else {
                            fullpageRoot.classList.add('visible');
                        }
                    },
                    onLeave: function(index, nextIndex, direction) {
                        const active = document.querySelector('.fp-section.active');
                        active.classList.add('already-animated');
                        active.classList.add('leaving');
                    },
                    //normalScrollElements: '.website-footer'
                });
                document.body.classList.add('svg-animated');

            } else {
                document.body.classList.add('svg-static');
                fullpageRoot.classList.add('visible');
                if (duplicateFooter) {
                    duplicateFooter.style.display = 'none';
                }
            }
        }
    }
}